import { Injectable, Signal } from "@angular/core"
import { AppSetting } from "./app-setting.model"
import { AppSettingStore } from "./app-setting.store"

@Injectable({ providedIn: 'root' })
export class AppSettingService {
    readonly appSetting: Signal<AppSetting | null>

    constructor(
        private _appSettingStore: AppSettingStore
    ) {
        this._appSettingStore.load()
        this.appSetting = this._appSettingStore.appsetting
    }



    //   getAnonymousUser(): CorpUserInfo {
    //     return new CorpUserInfo({
    //       name: "Anonymous user",
    //       samAccountName: "ANONYMOUS",
    //       isAuthorized: true
    //     });
    //   }

    //   getManazUser(): Observable<CorpUserInfo> {
    //     const url = `${this.appSettingStore.service()?.baseUrl}/manaz/api/userroles/${this.appSettingStore.name()}`;
    //     return this.http
    //       .get<CorpUserInfo>(url, { withCredentials: true })
    //       .pipe(
    //         tap(user => {

    //         }),
    //         map(user => ({
    //           ...user,
    //           isAuthorized: (user?.roles?.length ?? 0) > 0
    //         }))
    //     );
    //   }
}
